_ = require 'underscore'
Auth = require 'db/auth'
Controller = require 'controller'
Dialog = require 'views/lib/dialog'
React = require 'react'
t = require('views/internal/recup-with-helpers')()
trackUe = require 'debug/trackUe'

InspirationBoards = {
  'education': {
    boardId: '5be9e0a4747e797af465cb3d'
    boardName: 'Student Research Project Board'
    optionName: 'Education'
    optionValue: 'education'
  }
  'project-management': {
    boardId: '5be9e04a3c41be557c21ce12'
    boardName: 'Project Manager Sample Board'
    optionName: 'Project Management'
    optionValue: 'project-management'
  }
  'wedding': {
    boardId: '5be9e415ff84ad7a588c024b'
    boardName: 'Plan A Wedding'
    optionName: 'Wedding'
    optionValue: 'wedding'
  }
  'business': {
    boardId: '5be9e0c981e2a24e668677d4'
    boardName: 'Company Overview'
    optionName: 'Business'
    optionValue: 'business'
  }
  'creative-arts': {
    boardId: '5be9e1fd2dc2b5715a4546f5'
    boardName: 'Podcast Editorial Workflow'
    optionName: 'Creative Arts'
    optionValue: 'creative-arts'
  }
  'engineering-it': {
    boardId: '5be9e328f0697318045cc0d3'
    boardName: 'Production Workflow'
    optionName: 'Engineering & IT'
    optionValue: 'engineering-it'
  }
  'event-planning': {
    boardId: '5be9e35e20e1991c0cede0a5'
    boardName: 'Event Planning'
    optionName: 'Event Planning'
    optionValue: 'event-planning'
  }
  'home': {
    boardId: '5be9e513f7a51835e16662db'
    boardName: 'Household Chores'
    optionName: 'Home'
    optionValue: 'home'
  }
  'marketing': {
    boardId: '5be9e1d47c41ac0e2979e745'
    boardName: 'Marketing Overview'
    optionName: 'Marketing'
    optionValue: 'marketing'
  }
  'personal-goals': {
    boardId: '5be9e2f37a690f713e1c0b8f'
    boardName: 'Life Goals'
    optionName: 'Personal Goals'
    optionValue: 'personal-goals'
  }
  'productivity': {
    boardId: '5be9e17f7f59e38086d6862e'
    boardName: 'Ultimate To-Do List'
    optionName: 'Productivity'
    optionValue: 'productivity'
  }
  'sales-crm': {
    boardId: '5be9e3df58d5bc1ede20bf7f'
    boardName: 'Sales — CRM Pipeline'
    optionName: 'Sales & CRM'
    optionValue: 'sales-crm'
  }
  'support': {
    boardId: '5be9e19a9cca75084265ddc4'
    boardName: 'Bug Reports'
    optionName: 'Support'
    optionValue: 'support'
  }
  'travel': {
    boardId: '5c0180d7969dc80ef7435c2d'
    boardName: 'Plan A Vacation'
    optionName: 'Travel'
    optionValue: 'travel'
  }
  'other': {
    boardId: '5c59e4d58db1a81e59de2ec3'
    boardName: 'Bucket List'
    optionName: 'Other'
    optionValue: 'other'
  }
}

class InspirationBoardPicker extends React.Component
  displayName: 'InspirationBoardPicker'

  constructor: ->
    super()
    # Randomize the list but keep Other at the end
    @randomizedInspirationBoardOptions = _.chain(InspirationBoards)
      .values()
      .reject((board) -> board.optionValue == 'other')
      .shuffle()
      .value()
    @randomizedInspirationBoardOptions.push(InspirationBoards['other'])

    @state = {
      isLoading: false
      isEnabled: false
      selected: ''
    }
    return

  onSelect: (e) =>
    @setState({
      isEnabled: e.target?.value != '',
      selected: e.target?.value
    })
    return

  onSubmit: =>
    if !@state.isEnabled || @state.isLoading
      return

    trackUe('board', 'submit', 'inspiration picker', '', '', 'by clicking submit button', @state.selected)

    @setState({ isLoading: true })
    selection = InspirationBoards[@state.selected]

    initialData = {
      name: selection.boardName
      idOrganization: ''
    }

    # The "assisted" creationMethod will keep this action from contributing to
    # our 2 in 7 metric.
    requestData = _.extend({
      creationMethod: 'assisted'
      idBoardSource: selection.boardId
      keepFromSource: 'cards'
      prefs_permissionLevel: 'private'
    }, initialData)

    Auth.me().boardList.create initialData, {
      @modelCache
      requestData: requestData
      success: (board) ->

        # This fixes an issue with idBoards not being updated at the time that
        # the board gets rendered and the client thinking the member is not on
        # the board
        if board.id !in (currentBoards = Auth.me().get('idBoards'))
          Auth.me().set('idBoards', currentBoards.concat(board.id))

        # On the inspiration board, we will render a popover explainging the
        # board's purpose.
        # - shouldShowInspirationExplanation will ensure it renders,
        # - inspirationBoardOptionName will give it the correct copy
        Controller.displayBoard({
          idBoard: board.id
          inspirationBoardOptionValue: selection.optionValue
          shouldShowInspirationExplanation: true
        }).done()

        # Dialog will be hidden by board-view, so the board underneath it is
        # not shown before new board renders.
        return
      error: ->
        Controller.displayErrorPage()
    }
    return

  onSkip: ->
    trackUe('board', 'dismiss', 'inspiration picker', '', '', 'by clicking skip button')
    Dialog.hide()
    return

  render: t.renderable ->
    t.div '.inspiration-picker', =>
      t.img '.inspiration-picker-banner', {
        src: require('images/onboarding-experiment/inline-inspirations-picker.png')
      }
      t.div '.inspiration-picker-inner', =>
        t.h1 ->
          t.text 'Welcome to Trello!'
        t.p ->
          t.text "You're nearly there. Let’s set you up with a Trello board so that you can start getting things done right away."

        t.label { htmlFor: 'inspiration-picker-select' }, ->
          t.text 'Tell us, how are you planning to use Trello?'
        t.div '.inspiration-picker-select-wrapper', =>
          t.select {
            className: t.classify {
              valid: !@state.isLoading
            }
            autofocus: 'true'
            tabIndex: '0'
            name: 'inspiration-picker-select'
            id: 'inspiration-picker-select'
            onChange: @onSelect
            disabled: @state.isLoading
          }, =>
            t.option { value: '' }, ->
              t.text 'Choose one...'
            for { optionName, optionValue } in @randomizedInspirationBoardOptions
              t.option { value: optionValue }, ->
                t.text optionName
          t.span '.dropdown-icon'

        t.button {
          className: t.classify {
            primary: true
            disabled: !@state.isEnabled || @state.isLoading
          }
          onClick: @onSubmit
        }, ->
          t.text 'Go To My Board!'

      if !@state.isLoading
        t.div '.inspiration-picker-skip', =>
          t.span onClick: @onSkip, ->
            t.text 'Skip this step.'

module.exports = InspirationBoardPicker


// WEBPACK FOOTER //
// ./app/scripts/views/board/inspiration-board-picker-component.coffee